/* Whether this browser was signed in last time, kept only so the next reload knows whether
 * to paint the dashboard frame before the bundle has parsed (public/theme-boot.js reads it,
 * public/boot.css draws it). It is a hint about what to paint and nothing else: the session
 * is the cookie, and what may be read is decided by the server on every request.
 */

const KEY = 'analytics-signed-in';

export function rememberSession(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    /* Storage blocked entirely. The frame is then never pre-painted, which is the old
       behaviour rather than a fault. */
  }
}
